import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Tours from './components/Tours';
import Horses from './components/Horses';
import Gallery from './components/Gallery';
import VideoShowcase from './components/VideoShowcase';
import Location from './components/Location';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { Toaster } from './components/ui/toaster';
import useReveal from './hooks/useReveal';

function App() {
  useReveal();

  return (
    <div className="App bg-[#faf7f2] text-[#2a2a28]">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Tours />
        <Horses />
        <Gallery />
        <VideoShowcase />
        <Location />
        <Contact />
      </main>
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;
